import DetailsSection, { DetailsSectionProps } from './DetailsSection';

export type { DetailsSectionProps };
export default DetailsSection;
